import { Chip } from '@liveauctioneers/hammer-ui-core/chips';
import { EducationalTipExcludeHouses } from '../PreferencesFilters/components/EducationalTipExcludeHouses';
import { fetchSearchAggregationsOnDemand } from '@/redux/modules/search/search.actions';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getUserExcludedHouses } from '@/redux/modules/search/exclusions/searchExclusions.selectors';
import { openExcludeHousesModal } from '@/redux/modules/modal';
import { QuickFilterName, useTrackQuickFilterPillClicked } from '@/utils/amplitude/analytics/searchPage';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';

const EXCLUDE_HOUSES_MODAL_CHIP_ID = 'exclude-auction-houses-modal-chip';

export const ExcludeAuctionHousesFilter = () => {
    const dispatch = useAppDispatch();
    const trackQuickFilterPillClicked = useTrackQuickFilterPillClicked();
    const userExcludedHouses = useAppSelector((state) => getUserExcludedHouses(state));
    const hasExcludedHouses = Boolean(Array.isArray(userExcludedHouses) && userExcludedHouses.length);

    const handleChipClick = useCallback(() => {
        trackQuickFilterPillClicked(QuickFilterName.ExcludeAuctionHouses);
        dispatch(fetchSearchAggregationsOnDemand());
        dispatch(openExcludeHousesModal());
    }, [dispatch, trackQuickFilterPillClicked]);

    return (
        <>
            <Chip
                id={EXCLUDE_HOUSES_MODAL_CHIP_ID}
                onClick={handleChipClick}
                selected={hasExcludedHouses}
            >
                {!hasExcludedHouses ? (
                    <FormattedMessage id="excludeAuctionHousesFilter.chip.title" />
                ) : (
                    <FormattedMessage
                        id="excludeAuctionHousesFilter.chip.titleWithCount"
                        values={{
                            count: userExcludedHouses.length,
                        }}
                    />
                )}
            </Chip>
            <EducationalTipExcludeHouses anchorSelect={EXCLUDE_HOUSES_MODAL_CHIP_ID} />
        </>
    );
};
